module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/product5.05fa9578.png";